const PLACEHOLDER_VAT = '000000000';

export function isPlaceholderVat(vat?: string | null): boolean {
  const trimmed = (vat ?? '').trim();
  return trimmed === '' || trimmed === PLACEHOLDER_VAT;
}

export function displayVatNumber(vat?: string | null): string | undefined {
  if (isPlaceholderVat(vat)) return undefined;
  return (vat ?? '').trim();
}

export function vatForFormField(vat?: string | null): string {
  return displayVatNumber(vat) ?? '';
}
